import Immutable from 'immutable';
import { Logger } from '../../../../src/app/services';

/**
 * Convert state from ImmutableJS to plain JS objects
 * @param state
 */
const stateTransformer = state => {
  const newState = {};

  Object.keys(state).forEach(i => {
    if (Immutable.Iterable.isIterable(state[i])) {
      newState[i] = state[i].toJS();
    } else {
      newState[i] = state[i];
    }
  });

  return newState;
};

export default function createMiddleware() {
  return store => next => action => {
    try {
      return next(action);
    } catch (err) {
      console.error('[logging-middleware] Reporting error', action.type, err); // eslint-disable-line

      const babelEnv = (typeof process !== 'undefined' && process.env && process.env.BABEL_ENV) || 'undefined';
      if (babelEnv !== 'mocha') {
        Logger.error(err, {
          action: {
            type: action.type,
            payload: action.payload,
            state: stateTransformer(store.getState()),
          }
        });
      }

      throw err;
    }
  };
}
